module.exports = __webpack_public_path__ + "img/home1.f1a6fefe.png";